$(document).ready(function () {

    if (!enableMoreDiv) {
        return;
    }

    var oesTextDiv = document.getElementsByClassName('oesText')[0];

    var moreMessage = '<i class="fa fa-plus-square-o"></i>';
    var lessMessage = '<i class="fa fa-minus-square-o"></i>';

    if (oesTextDiv) {

        var originalAddClassMethod = jQuery.fn.addClass;
        var originalRemoveClassMethod = jQuery.fn.removeClass;
        $.fn.addClass = function () {
            var result = originalAddClassMethod.apply(this, arguments);
            $(this).trigger('classChanged');
            return result;
        };

        $.fn.removeClass = function () {
            var result = originalRemoveClassMethod.apply(this, arguments);
            $(this).trigger('classChanged');
            return result;
        };

        var seeMoreLink = document.createElement("a");
        seeMoreLink.id = "seeMoreLink";
        seeMoreLink.innerHTML = moreMessage;
        seeMoreLink.href = "#more";
        seeMoreLink.className = "more-link";
        seeMoreLink.style.cssText = "display: none;";
        oesTextDiv.parentNode.insertBefore(seeMoreLink, oesTextDiv.nextSibling);

        oesTextDiv.classList.add("showOesText");
        oesTextDiv.classList.remove("hideOesText");

        oesTextDiv.style.overflow = "visible";
        truncateText($(oesTextDiv));
        checkTruncated($(oesTextDiv));

        $(oesTextDiv).on("classChanged", function () {
            checkTruncated($(this));
        });

        $('#seeMoreLink').on('click', function (event) {
            event.preventDefault();
            var $this = $(this);
            var $content = $this.prev('div.oesText');
            if ($content.hasClass("hideOesText")) {
                $content.removeClass("hideOesText");
                $content.addClass("showOesText");
                $this.html(lessMessage);
                $content.trigger("destroy");
            } else {
                $content.removeClass("showOesText");
                $content.addClass("hideOesText");
                $this.html(moreMessage);
                truncateText($content);
            }
        });
    }

    function truncateText(elem) {
        elem.dotdotdot({
            ellipsis: " ...",
            watch: true
        });
    }

    function checkTruncated($oesTextDiv) {
        var $seeMoreLink = $('#seeMoreLink');
        if (!$seeMoreLink.length) {
            return;
        }
        if ($oesTextDiv.hasClass('is-truncated')) {
            $seeMoreLink.show();
        }

        if (!$oesTextDiv.hasClass('is-truncated')) {
            $seeMoreLink.hide();
        }
    }
});